import { cloneElement, Fragment, isValidElement, ReactElement } from 'react';

type SkeletonFill<Props> = {
  count?: number;
  children: ReactElement<Props>;
};

export const SkeletonFill = <Props,>({
  count = 10,
  children,
}: SkeletonFill<Props>): ReactElement => {
  if (!isValidElement(children))
    throw new Error('skeletonComponent props is not a valid React element.');

  return (
    <Fragment>
      {Array(count)
        .fill(children)
        .map((component: ReactElement, index) => {
          return cloneElement(component, { ...children.props, key: index });
        })}
    </Fragment>
  );
};
